// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SGI Container Styles
 * 
 * Layout ajustado dinamicamente via React/JS
 */

.sgi-container {
    position: absolute;
    top: 0;
    left: 0;
    /* right e bottom são definidos inline via JS */
    display: flex;
    flex-direction: column;
    background: #1a1a2e;
    /* Z-index reduzido para permitir notificações do Jitsi acima */
    z-index: 10;
    transition: right 0.3s ease, bottom 0.3s ease;
}

.sgi-iframe {
    flex: 1;
    width: 100%;
    border: none;
    background: #0d0d1a;
}

/* Responsivo para telas menores - ajustes extras se necessário */

@media (max-width: 768px) {
    /* JS gerencia a maior parte, mas em mobile podemos querer ocupar tudo */
}`, "",{"version":3,"sources":["webpack://./react/features/sgi/components/web/SGIContainer.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,+CAA+C;IAC/C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,+DAA+D;IAC/D,WAAW;IACX,6CAA6C;AACjD;;AAEA;IACI,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA,iEAAiE;;AAEjE;IACI,wEAAwE;AAC5E","sourcesContent":["/**\n * SGI Container Styles\n * \n * Layout ajustado dinamicamente via React/JS\n */\n\n.sgi-container {\n    position: absolute;\n    top: 0;\n    left: 0;\n    /* right e bottom são definidos inline via JS */\n    display: flex;\n    flex-direction: column;\n    background: #1a1a2e;\n    /* Z-index reduzido para permitir notificações do Jitsi acima */\n    z-index: 10;\n    transition: right 0.3s ease, bottom 0.3s ease;\n}\n\n.sgi-iframe {\n    flex: 1;\n    width: 100%;\n    border: none;\n    background: #0d0d1a;\n}\n\n/* Responsivo para telas menores - ajustes extras se necessário */\n\n@media (max-width: 768px) {\n    /* JS gerencia a maior parte, mas em mobile podemos querer ocupar tudo */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
